import { lazyGettext } from '@eb/lazy-gettext';
import {
    PACKAGE_ONE,
    PACKAGE_ONE_NAME,
    PACKAGE_THREE,
    PACKAGE_THREE_NAME,
    PACKAGE_TWO,
    PACKAGE_TWO_NAME,
    SHOW_LOW_ATV_UI,
} from '../../constants/main';

import {
    CREATE_AN_EVENT,
    CREATE_LISTING,
    GET_STARTED,
    GET_STARTED_MINUTES,
    GET_STARTED_SOLUTION,
    TAKE_CONTROL,
    TRACK_ANALYTICS,
    VIEW_PRICING,
} from '../../constants/overview';

export default {
    [SHOW_LOW_ATV_UI]: {
        getStartedHeading: {
            heading: GET_STARTED_MINUTES,
            description: CREATE_LISTING,
            CTAText: GET_STARTED,
            imageBackgroundColor: 'mellow-pink',
            imagePath: 'overview/devices-create',
        },
        takeControlHeading: {
            heading: TAKE_CONTROL,
            description: TRACK_ANALYTICS,
            CTAText: CREATE_AN_EVENT,
            imageBackgroundColor: 'smart-blue',
            imagePath: 'overview/img-devices-dashboard',
        },
        packagesList: {
            heading: GET_STARTED_SOLUTION,
            CTA: VIEW_PRICING,
            packages: {
                [PACKAGE_ONE]: {
                    name: PACKAGE_ONE_NAME,
                    description: lazyGettext(
                        'The essentials you need to start selling tickets in minutes.',
                    ),
                },
                [PACKAGE_TWO]: {
                    name: PACKAGE_TWO_NAME,
                    description: lazyGettext(
                        'A powerful solution to boost sales and grow your business.',
                    ),
                },
                [PACKAGE_THREE]: {
                    name: PACKAGE_THREE_NAME,
                    description: lazyGettext(
                        'Tailored partnership for organizers with large and complex events.',
                    ),
                },
            },
        },
    },
};
